import {
	all,
	call,
	fork,
	put,
	takeEvery,
	takeLatest,
} from 'redux-saga/effects';
// redux actions
import * as actions from '../actions';
import * as actionTypes from './actionTypes';
// Api methods
import { api, FormField } from 'api';
// interface
import { AxiosResponse } from 'axios';
import {
	CalcType,
	Constant,
	Formula,
	MoveDirection,
	Operation,
	Parameter,
	Rule,
	RuleTest,
	SaveRes,
	SaveStatus,
	Variable,
} from 'api';

export interface IGetParamsPayload {
	payload: CalcType;
	type: typeof actionTypes.GET_PARAMETERS;
}

export interface IGetFormFieldsPayload {
	payload: CalcType;
	type: typeof actionTypes.GET_FORM_FIELDS;
}

function* sagaGetParams({ payload }: IGetParamsPayload) {
	try {
		const response: AxiosResponse<Array<Parameter>> =
			yield api.calculation.apiCalculationDataGetParametersGet(payload);
		console.log(
			'SAGA|getParams',
			'api/CalculationData/GetParameters?',
			response.data
		);

		if (response.data) {
			yield put(actions.setParams(response.data));
		} else {
			yield put(
				actions.apiResError('Error on getting application parameters!')
			);
		}
	} catch (error: any) {
		console.log('SAGA|getParams|error', error);
		yield put(actions.saveError(error.message));
	}
}

function* getFormFields({ payload }: IGetFormFieldsPayload){
	try {
		const response: AxiosResponse<Array<FormField>> =
			yield api.calculation.apiCalculationDataGetFormFieldsGet(payload);
		console.log(
			'SAGA|getFormFields',
			'api/CalculationData/GetFormFields?',
			response.data
		);

		if (response.data) {
			yield put(actions.setFormFields(response.data));
		} else {
			yield put(
				actions.apiResError('Error on getting application parameters!')
			);
		}
	} catch (error: any) {
		console.log('SAGA|getFormFields|error', error);
		yield put(actions.saveError(error.message));
	}
}

function* sagaGetOperations() {
	try {
		const response: AxiosResponse<Array<Operation>> =
			yield api.calculation.apiCalculationDataGetOperationsGet(); // korigirati backend api
		console.log(
			'SAGA|getOperations',
			'api/CalculationData/GetOperations?',
			response.data
		);

		if (response.data) {
			yield put(actions.setOperations(response.data));
		} else {
			yield put(
				actions.apiResError('Error on getting application operations!')
			);
		}
	} catch (error: any) {
		console.log('SAGA|getOperations|error', error);
		yield put(actions.saveError(error.message));
	}
}

export interface IGetVariablesPayload {
	payload: CalcType;
	type: typeof actionTypes.GET_VARIABLES;
}
function* sagaGetVariables({ payload }: IGetVariablesPayload) {
	try {
		const response: AxiosResponse<Array<Variable>> =
			yield api.calculation.apiCalculationDataGetVariablesGet(payload);
		console.log(
			'SAGA|getVariables',
			'api/CalculationData/getVariables?',
			response.data
		);

		if (response.data) {
			yield put(actions.setVariables(response.data));
		} else {
			yield put(
				actions.apiResError('Error on getting application variables!')
			);
		}
	} catch (error: any) {
		console.log('SAGA|getVariables|error', error);
		yield put(actions.saveError(error.message));
	}
}

function* sagaGetConstants() {
	try {
		const response: AxiosResponse<Array<Constant>> =
			yield api.calculation.apiCalculationDataGetConstantsGet();
		console.log(
			'SAGA|getConstants',
			'api/CalculationData/getConstants?',
			response.data
		);

		if (response.data) {
			yield put(actions.setConstants(response.data));
		} else {
			yield put(
				actions.apiResError('Error on getting application Constants!')
			);
		}
	} catch (error: any) {
		console.log('SAGA|getConstants|error', error);
		yield put(actions.saveError(error.message));
	}
}

export interface ISaveConstantPayload {
	payload: Constant;
	type: typeof actionTypes.SAVE_CONSTANT;
}
function* sagaSaveConstant({ payload }: ISaveConstantPayload) {
	try {
		if (payload.name === undefined) {
			yield put(actions.apiResError('Please enter name.'));
		} else if (payload.value?.valueType === undefined) {
			yield put(actions.apiResError('Please enter value.'));
		} else {
			const response: AxiosResponse<SaveRes> =
				yield api.calculation.apiCalculationDataConstantPost(payload);
			console.log(
				'SAGA|saveConstant',
				'api/CalculationData/saveConstant?',
				response.data
			);

			if (response.data.status === SaveStatus.Success) {
				yield call(sagaGetConstants);
				yield put(
					actions.apiResSuccess('System value saved successfully')
				);
				yield put(
					actions.setConstantId(response.data.createdId as number)
				);
			} else {
				yield put(actions.apiResError(response.data.message));
			}
		}
	} catch (error: any) {
		console.log('SAGA|saveConstant|error', error);
		const d = JSON.parse(error.config.data);
		yield put(
			actions.apiResError(
				`An error occurred! ${d.name} system value not saved.`
			)
		);
		yield put(actions.saveError(error.message));
	}
}

export interface IUpdateConstantPayload {
	payload: Constant;
	type: typeof actionTypes.UPDATE_CONSTANT;
}
function* sagaUpdateConstant({ payload }: IUpdateConstantPayload) {
	try {
		if (payload?.value?.valueType === undefined) {
			yield put(actions.apiResError('Please enter value.'));
		} else if (payload?.value?.valueType === undefined) {
			yield put(actions.apiResError('Please enter value.'));
		}
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataConstantIdPut(
				Number(payload.id),
				payload
			);
		console.log(
			'SAGA|updateConstant',
			'api/CalculationData/updateConstant?',
			response.data
		);

		if (response.data.status === SaveStatus.Success) {
			yield put(
				actions.apiResSuccess('System value updated successfully')
			);
			yield put(actions.setConstantId(response.data.createdId as number));
			yield call(sagaGetConstants);
		} else {
			yield put(actions.apiResError(response.data.message));
		}
	} catch (error: any) {
		console.log('SAGA|updateConstant|error', error);
		const d = JSON.parse(error.config.data);
		yield put(
			actions.apiResError(
				`An error occurred! ${d.name} system value not updated.`
			)
		);
		yield put(actions.saveError(error.message));
	}
}

export interface IGetDefinitionsPayload {
	payload: number;
	type: typeof actionTypes.GET_FORMULAE_DEFS;
}
function* sagaGetDefinitions({ payload }: IGetDefinitionsPayload) {
	try {
		const response: AxiosResponse<Array<Formula>> =
			yield api.calculation.apiCalculationDataDefinitionsIdGet(payload); // korigirati backend api
		console.log(
			'SAGA|getDefinitions',
			'api/CalculationData/GetDefinitions?',
			response.data
		);

		if (response.data) {
			yield put(actions.setDefinitions(response.data));
		} else {
			yield put(
				actions.apiResError(
					'Error on getting definitions for rule formulae!'
				)
			);
		}
	} catch (error: any) {
		console.log('SAGA|getDefinitions|error', error);
		yield put(actions.saveError(error.message));
	}
}

export interface IGetRulesPayload {
	payload: CalcType;
	type: typeof actionTypes.GET_RULES;
}

function* sagaGetRules({ payload }: IGetRulesPayload) {
	try {
		const response: AxiosResponse<Array<Rule>> =
			yield api.calculation.apiCalculationDataRulesCalcTypeGet(payload);
		console.log(
			'SAGA|getRules',
			'/api/CalculationData/GetRules?calcType=' + payload,
			response.data
		);

		if (response.data) {
			yield put(actions.setRules(response.data));
		} else {
			yield put(
				actions.apiResError('Error on getting calculator rules!')
			);
		}
	} catch (error: any) {
		console.log('SAGA|getRules|error', error);
		yield put(actions.saveError(error.message));
	}
}

export interface IGetRulePayload {
	payload: number;
	type: typeof actionTypes.GET_RULE;
}

function* sagaGetRule({ payload }: IGetRulePayload) {
	try {
		const response: AxiosResponse<Rule> =
			yield api.calculation.apiCalculationDataRuleIdGet(payload);
		console.log(
			'SAGA|getRule',
			'/api/CalculationData/GetRule?id=' + payload,
			response.data
		);

		if (response.data) {
			yield put(actions.setRule(response.data));
		} else {
			yield put(actions.apiResError('Error on getting rule definition!'));
		}
	} catch (error: any) {
		console.log('SAGA|getRule|error', error);
		yield put(actions.saveError(error.message));
	}
}

export interface IGetFormulaePayload {
	payload: number;
	type: typeof actionTypes.GET_FORMULAE;
}

function* sagaGetFormulae({ payload }: IGetFormulaePayload) {
	try {
		const response: AxiosResponse<Array<Formula>> =
			yield api.calculation.apiCalculationDataFormulaeRuleIdGet(payload);
		console.log(
			'SAGA|getFormulae',
			'/api/CalculationData/GetFormulae?ruleId=' + payload,
			response.data
		);

		if (response.data) {
			yield put(actions.setFormulae(response.data));
		} else {
			yield put(
				actions.apiResError('Error on getting formulae definition!')
			);
		}
	} catch (error: any) {
		console.log('SAGA|getFormulae|error', error);
		//yield put(getRulesError(error));
		yield put(actions.apiResError(error.message));
	}
}

export interface IGetFormulaPayload {
	payload: number;
	type: typeof actionTypes.GET_FORMULA;
}

function* sagaGetFormula({ payload }: IGetFormulaPayload) {
	try {
		const response: AxiosResponse<Formula> =
			yield api.calculation.apiCalculationDataFormulaIdGet(payload);
		console.log(
			'SAGA|getRule',
			'/api/CalculationData/GetRule?id=' + payload,
			response.data
		);

		if (response.data) {
			yield put(actions.setFormula(response.data));
		} else {
			yield put(
				actions.apiResError('Error on getting formula definition!')
			);
		}
	} catch (error: any) {
		console.log('SAGA|getFormula|error', error);
		yield put(actions.saveError(error.message));
	}
}

export interface ISaveRulePayload {
	payload: Rule;
	type: typeof actionTypes.SAVE_RULE;
}

function* sagaSaveRule({ payload }: ISaveRulePayload) {
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataRulePut(payload);
		console.log(
			'SAGA|saveRule',
			'api/CalculationData/Rule?',
			response.data
		);

		if (response.data.status === SaveStatus.Success) {
			yield put(actions.apiResSuccess('Rule saved successfully!'));
			yield call(sagaGetVariables, {
				payload: payload.calcType,
				type: actionTypes.GET_VARIABLES,
			});
			yield call(sagaGetRules, {
				payload: payload.calcType,
				type: actionTypes.GET_RULES,
			});
		} else {
			yield put(actions.apiResError('Error on rule save!'));
		}
	} catch (error: any) {
		console.log('SAGA|saveRule|error', error);
		const d = JSON.parse(error.config.data);
		yield put(
			actions.apiResError(`An error occurred! ${d.name} rule not saved.`)
		);
		yield put(actions.saveError(error.message));
	}
}

export interface ICopyRulePayload {
	payload: {
		ruleId: number;
		calcType: CalcType;
		name: string;
	};
	type: typeof actionTypes.COPY_RULE;
}

function* sagaCopyRule({ payload }: ICopyRulePayload) {
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataCopyRuleIdPost(
				payload.ruleId,
				payload.calcType,
				payload.name
			);
		console.log(
			'SAGA|copyRule',
			'api/CalculationData/Rule?ruleId=' +
				payload.ruleId +
				'&calcType=' +
				payload.calcType,
			response.data
		);

		if (response.data.status === SaveStatus.Success) {
			yield put(
				actions.apiResSuccess('Rule copied and saved successfully!')
			);
			yield put(actions.setCalcType(payload.calcType));
			yield call(sagaGetRules, {
				payload: payload.calcType,
				type: actionTypes.GET_RULES,
			});
		} else {
			yield put(actions.apiResError('Error on rule save!'));
		}
	} catch (error: any) {
		console.log('SAGA|copyRule|error', error);
		const d = JSON.parse(error.config.data);
		yield put(
			actions.apiResError(`An error occurred! ${d.name} rule not saved.`)
		);
		yield put(actions.saveError(error.message));
	}
}

export interface IUpdateRulePayload {
	payload: {
		id: number;
		rule: Rule;
	};
	type: typeof actionTypes.UPDATE_RULE;
}

function* sagaUpdateRule({ payload }: IUpdateRulePayload) {
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataRuleIdPost(
				payload.id,
				payload.rule
			); // korigirati backend api
		console.log(
			'SAGA|updateRule',
			'api/CalculationData/Rule?id=' + payload.id,
			response.data
		);

		if (response.data.status === SaveStatus.Success) {
			yield put(actions.apiResSuccess('Rule updated successfully!'));
			yield call(sagaGetVariables, {
				payload: payload.rule.calcType,
				type: actionTypes.GET_VARIABLES,
			});
			yield call(sagaGetRules, {
				payload: payload.rule.calcType,
				type: actionTypes.GET_RULES,
			});
		} else {
			yield put(actions.apiResError(response.data.message));
		}
	} catch (error: any) {
		console.log('SAGA|updateRule|error', error);
		const d = JSON.parse(error.config.data);
		yield put(
			actions.apiResError(
				`An error occurred! ${d.name} rule not updated.`
			)
		);
		yield put(actions.saveError(error.message));
	}
}

export interface IDeleteRulePayload {
	payload: {
		id: number;
		calcType: CalcType;
	};
	type: typeof actionTypes.DELETE_RULE;
}

function* sagaDeleteRule({ payload }: IDeleteRulePayload) {
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataRuleIdDelete(payload.id); // korigirati backend api
		console.log(
			'SAGA|deleteRule',
			'api/CalculationData/Rule?',
			response.data
		);

		if (response.data.status === SaveStatus.Success) {
			yield put(actions.apiResSuccess('Rule deleted sucessfully!'));
			yield put(actions.deletedRule(response.data));
			yield call(sagaGetRules, {
				payload: payload.calcType,
				type: actionTypes.GET_RULES,
			});
		} else {
			yield put(actions.apiResError(response.data.message));
		}
	} catch (error: any) {
		console.log('SAGA|deleteRule|error', error);
		yield put(actions.saveError(error.message));
	}
}

export interface ITestRulePayload {
	payload: Rule;
	type: typeof actionTypes.TEST_RULE;
}

function* sagaTestRule({ payload }: ITestRulePayload) {
	try {
		const response: AxiosResponse<RuleTest> =
			yield api.calculation.apiCalculationDataTestRulePost(payload); // korigirati backend api
		console.log(
			'SAGA|testRule',
			'api/CalculationData/TestRule?',
			response.data
		);

		if (response.data) {
			yield put(actions.testedRule(response.data));
		} else {
			yield put(actions.apiResError('Error on testing rule!'));
		}
	} catch (error: any) {
		console.log('SAGA|testRule|error', error);
		yield put(actions.testError(false));
	}
}

export interface ISaveFormulaPayload {
	payload: {
		id: number;
		formula: Formula;
	};
	type: typeof actionTypes.SAVE_FORMULA;
}

function* sagaSaveFormula({ payload }: ISaveFormulaPayload) {
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataFormulaRuleIdPut(
				payload.id,
				payload.formula
			);
		console.log(
			'SAGA|saveFormula',
			'api/CalculationData/Rule?ruleId=' + payload.id,
			response.data
		);

		if (response.data.status === SaveStatus.Success) {
			yield put(actions.apiResSuccess('Formula saved successfully!'));
			if (response.data.createdId)
				yield call(sagaGetDefinitions, {
					payload: payload.id,
					type: actionTypes.GET_FORMULAE_DEFS,
				});
		} else {
			yield put(actions.apiResError(response.data.message));
		}
	} catch (error: any) {
		console.log('SAGA|saveFormula|error', error);
		const d = JSON.parse(error.config.data);
		yield put(
			actions.apiResError(
				`An error occurred! ${d.name} formula not saved.`
			)
		);
		yield put(actions.saveError(error.message));
	}
}

export interface IUpdateFormulaPayload {
	payload: {
		id: number;
		formula: Formula;
	};
	type: typeof actionTypes.UPDATE_FORMULA;
}

function* sagaUpdateFormula({ payload }: IUpdateFormulaPayload) {
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataFormulaIdPost(
				payload.id,
				payload.formula
			); // korigirati backend api
		console.log(
			'SAGA|updateFormula',
			'api/CalculationData/Formula?id=' + payload.formula.id,
			response.data
		);

		if (response.data.status === SaveStatus.Success) {
			yield put(actions.apiResSuccess('Updated formula successfully!'));
			yield call(sagaGetDefinitions, {
				payload: payload.id,
				type: actionTypes.GET_FORMULAE_DEFS,
			});
		} else {
			yield put(actions.apiResError(response.data.message));
		}
	} catch (error: any) {
		console.log('SAGA|updateFormula|error', error);
		const d = JSON.parse(error.config.data);
		yield put(
			actions.apiResError(
				`An error occurred! ${d.name} formula not updated.`
			)
		);
		yield put(actions.saveError(error.message));
	}
}

export interface IDeleteFormulaPayload {
	payload: {
		ruleId: number;
		formulaId: number;
	};
	type: typeof actionTypes.DELETE_FORMULA;
}

function* sagaDeleteFormula({
	payload: { ruleId, formulaId },
}: IDeleteFormulaPayload) {
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataFormulaIdDelete(formulaId);
		console.log(
			'SAGA|deleteFormula',
			'api/CalculationData/Formula?id=' + formulaId,
			response.data
		);

		if (response.data.status === SaveStatus.Success) {
			yield put(actions.apiResSuccess('Deleted formula successfully!'));
			yield call(sagaGetDefinitions, {
				payload: ruleId,
				type: actionTypes.GET_FORMULAE_DEFS,
			});
		} else {
			yield put(actions.apiResError(response.data.message));
		}
	} catch (error: any) {
		console.log('SAGA|deleteFormula|error', error);
		const d = JSON.parse(error.config.data);
		yield put(
			actions.apiResError(
				`An error occurred! ${d.name} formula not updated.`
			)
		);
		yield put(actions.saveError(error.message));
	}
}

export interface IMoveFormulaPayload {
	payload: {
		formulaId: number;
		ruleId: number;
		direction: MoveDirection;
	};
	type: typeof actionTypes.MOVE_FORMULA;
}

function* sagaMoveFormula({
	payload: { formulaId, ruleId, direction },
}: IMoveFormulaPayload) {
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataMoveFormulaIdDirectionPost(
				formulaId,
				direction
			);
		console.log(
			'SAGA|moveFormula',
			'api/CalculationData/Formula?id=' + formulaId,
			response.data
		);

		if (response.data.status === SaveStatus.Success) {
			yield call(sagaGetDefinitions, {
				payload: ruleId,
				type: actionTypes.GET_FORMULAE_DEFS,
			});
		} else {
			yield put(actions.apiResError(response.data.message));
		}
	} catch (error: any) {
		console.log('SAGA|moveFormula|error', error);
		const d = JSON.parse(error.config.data);
		yield put(
			actions.apiResError(
				`An error occurred! ${d.name} formula not updated.`
			)
		);
		yield put(actions.saveError(error.message));
	}
}

export interface IMoveRulePayload {
	payload: {
		ruleId: number;
		direction: MoveDirection;
		calcType: CalcType;
	};
	type: typeof actionTypes.MOVE_RULE;
}

function* sagaMoveRule({
	payload: { ruleId, direction, calcType },
}: IMoveRulePayload) {
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataMoveRuleIdDirectionPost(
				ruleId,
				direction
			);
		console.log(
			'SAGA|moveRule',
			'api/CalculationData/MoveRule?id=' + ruleId,
			response.data
		);

		if (response.data.status === SaveStatus.Success) {
			yield put(actions.apiResSuccess(response.data.message));
			yield call(sagaGetRules, {
				payload: calcType,
				type: actionTypes.GET_RULES,
			});
		} else {
			yield put(actions.apiResError(response.data.message));
		}
	} catch (error: any) {
		console.log('SAGA|moveRule|error', error);
		const d = JSON.parse(error.config.data);
		yield put(
			actions.apiResError(
				`An error occurred! ${d.name} rule not updated.`
			)
		);
		yield put(actions.saveError(error.message));
	}
}

export interface IDeleteConstantPayLoad {
	payload: {
		constantId: number;
	};
	type: typeof actionTypes.DELETE_CONSTANT;
}

function* sagaDeleteConstant({
	payload: { constantId },
}: IDeleteConstantPayLoad) {
	try {
		const response: AxiosResponse<SaveRes> =
			yield api.calculation.apiCalculationDataConstantIdDelete(
				constantId
			);
		console.log(
			'SAGA|deleteConstant',
			'api/CalculationData/Constant?id=' + constantId,
			response.data
		);

		if (response.data && response.data.status === SaveStatus.Success) {
			yield put(actions.apiResSuccess('Deleted constant successfully!'));
			yield put(actions.deletedConstant(response.data));
			yield call(sagaGetConstants);
		} else {
			if (
				response.data &&
				response.data.message &&
				response.data.message.includes('Referenced in other entities')
			) {
				yield put(
					actions.apiResError(
						'Error deleting constant because it is used in other entities.'
					)
				);
			} else {
				yield put(actions.apiError('Error deleting constant.'));
			}
		}
	} catch (error: any) {
		console.log('SAGA|deleteConstant|error', error);
		yield put(
			actions.apiResError(
				`An error occurred while deleting constant: ${error.message}`
			)
		);
		yield put(actions.saveError(error.message));
	}
}

export function* watchGetRules() {
	yield takeLatest(actionTypes.GET_RULES, sagaGetRules); // get rules for current calculator type
}
export function* watchGetRule() {
	yield takeLatest(actionTypes.GET_RULE, sagaGetRule); // get single rule definition
}

export function* watchGetFormulae() {
	yield takeLatest(actionTypes.GET_FORMULAE, sagaGetFormulae); // get single rule definition
}
export function* watchGetFormula() {
	yield takeLatest(actionTypes.GET_FORMULA, sagaGetFormula); // get single rule definition
}

export function* watchGetParameters() {
	yield takeLatest(actionTypes.GET_PARAMETERS, sagaGetParams);
}
export function* watchGetVariables() {
	yield takeLatest(actionTypes.GET_VARIABLES, sagaGetVariables);
}
export function* watchGetConstants() {
	yield takeLatest(actionTypes.GET_CONSTANTS, sagaGetConstants);
}
export function* watchSaveConstant() {
	yield takeLatest(actionTypes.SAVE_CONSTANT, sagaSaveConstant);
}
export function* watchUpdateConstant() {
	yield takeLatest(actionTypes.UPDATE_CONSTANT, sagaUpdateConstant);
}
export function* watchGetOperations() {
	yield takeLatest(actionTypes.GET_OPERATIONS, sagaGetOperations);
}
export function* watchGetDefinitions() {
	yield takeLatest(actionTypes.GET_FORMULAE_DEFS, sagaGetDefinitions);
}
export function* watchSaveRule() {
	yield takeLatest(actionTypes.SAVE_RULE, sagaSaveRule);
}
export function* watchCopyRule() {
	yield takeEvery(actionTypes.COPY_RULE, sagaCopyRule);
}
export function* watchSaveFormula() {
	yield takeEvery(actionTypes.SAVE_FORMULA, sagaSaveFormula);
}
export function* watchUpdateRule() {
	yield takeEvery(actionTypes.UPDATE_RULE, sagaUpdateRule);
}
export function* watchDeleteRule() {
	yield takeEvery(actionTypes.DELETE_RULE, sagaDeleteRule);
}
export function* watchDeleteFormula() {
	yield takeEvery(actionTypes.DELETE_FORMULA, sagaDeleteFormula);
}
export function* watchTestRule() {
	yield takeLatest(actionTypes.TEST_RULE, sagaTestRule);
}
export function* watchUpdateFormula() {
	yield takeEvery(actionTypes.UPDATE_FORMULA, sagaUpdateFormula);
}
export function* watchMoveFormula() {
	yield takeEvery(actionTypes.MOVE_FORMULA, sagaMoveFormula);
}
export function* watchMoveRule() {
	yield takeEvery(actionTypes.MOVE_RULE, sagaMoveRule);
}
export function* watchDeleteConstant() {
	yield takeEvery(actionTypes.DELETE_CONSTANT, sagaDeleteConstant);
}
export function* watchGetFormFields() {
	yield takeEvery(actionTypes.GET_FORM_FIELDS, getFormFields);
}

function* calcWizardSaga() {
	yield all([
		fork(watchGetRules),
		fork(watchGetRule),
		fork(watchGetFormulae),
		fork(watchGetFormula),
		fork(watchMoveRule),
		fork(watchSaveRule),
		fork(watchCopyRule),
		fork(watchSaveFormula),
		fork(watchUpdateRule),
		fork(watchDeleteRule),
		fork(watchDeleteFormula),
		fork(watchTestRule),
		fork(watchUpdateFormula),
		fork(watchMoveFormula),
		fork(watchGetParameters),
		fork(watchGetOperations),
		fork(watchGetVariables),
		fork(watchGetConstants),
		fork(watchSaveConstant),
		fork(watchUpdateConstant),
		fork(watchGetDefinitions),
		fork(watchDeleteConstant),
		fork(watchGetFormFields),
	]);
}

export default calcWizardSaga;
